import zappy from "@zappy-ride/library.react.components";
import { OutputCharging } from "./Charging";

export * from "./Charging";

zappy.FactoryInstance.registerComponent(OutputCharging);
